import {JW_TYPE} from "./enums/RoadKillEnums";
import {RKHelper} from "../utils/RKHelper";
import {gsap, TimelineLite} from "gsap";
import {RoadKill} from "../RoadKill";
import {RoadKillSound} from "../sound/RoadKillSound";


export class AnimalHeadCount extends PIXI.spine.Spine {
    private readonly _type: JW_TYPE;

    constructor(spineData: PIXI.spine.core.SkeletonData, type: JW_TYPE) {
        super(spineData);
        this._type = type;
        this.init();
    }

    private _value: number = 0;

    get value(): number {
        return this._value;
    }

    public setValue(value: number, isRestore: boolean = false): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        if (value > 0 && value < 6 && this._value != value) {
            this._value = value;
            if (!this.visible) {
                tl.add(() => {
                    this.alpha = 0;
                    this.visible = true;
                });
                tl.to(this, {duration: 0.01, alpha: 1});
            }
            tl.add([RKHelper.playSpineWithTimeline(this, 0, "hit" + value), () => {
                if (!RoadKill.model.isRestore) {
                    RoadKill.soundPlayer.playTrack(RoadKillSound.ADD_HIT_LINE_SOUND);
                }
            }], 0);
            if (isRestore) {
                tl.timeScale(100);
            }
        }
        return tl;
    }

    public playPopIn(animationName: string): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        if (!this.visible) {
            tl.add(() => {
                this.alpha = 0;
                this.visible = true;
                gsap.to(this, {duration: 0.01, alpha: 1});
            });
        }
        tl.add(RKHelper.playSpineWithTimeline(this, 0, animationName), 0);
        tl.add(() => {
            RoadKill.soundPlayer.playTrack(RoadKillSound.PLANK_SOUND_2);
        }, this.skeleton.data.findAnimation(animationName).duration / 1.5);
        return tl;
    }

    public playPopOut(animationName: string): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this._value = 0;
        })
        tl.add(RKHelper.playSpineWithTimeline(this, 0, animationName), 0);
        return tl;
    }

    public hide(): void {
        this.visible = false;
    }

    private init(): void {
        this.y = 66;
        this.name = "JW_" + this._type;
    }
}